{ "compressionlevel":-1,
 "height":10,
 "infinite":false,
 "layers":[
        {
         "data":[64, 4, 64, 64, 4, 4, 4, 4, 9, 64, 12, 2, 2, 64, 15, 2, 2, 4, 3, 64, 4, 64, 1, 4, 2, 64, 2, 64, 2, 64, 4, 64, 2, 4, 2, 64, 2, 8, 2, 64, 4, 17, 2, 64, 2, 4, 4, 64, 1, 10, 4, 2, 64, 64, 3, 2, 4, 64, 2, 64, 64, 2, 64, 64, 64, 2, 17, 2, 2, 64, 64, 2, 2, 2, 64, 2, 2, 64, 3, 4, 3, 2, 64, 2, 64, 64, 2, 64, 2, 4, 4, 4, 4, 3, 2, 2, 2, 64, 11, 64],
         "height":10,
         "id":1,
         "name":"tiles",
         "opacity":1,
         "type":"tilelayer",
         "visible":true,
         "width":10,
         "x":0,
         "y":0
        }],
 "nextlayerid":2,
 "nextobjectid":1,
 "orientation":"orthogonal",
 "renderorder":"right-down",
 "tiledversion":"1.6.0",
 "tileheight":32,
 "tilesets":[
        {
         "firstgid":1,
         "source":"tileset.tsx"
        }],
 "tilewidth":32,
 "type":"map",
 "version":"1.6",
 "width":10
}